type ConnectorVariant = "top" | "middle" | "bottom";

export const getConnectorVariant = (index: number, total: number): ConnectorVariant => {
  if (index <= 0 || total <= 1) {
    return "top";
  }

  if (index >= total - 1) {
    return "bottom";
  }

  return "middle";
};
